import { get, find } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { persistor } from "~/store";
import { setCSToken } from "~/store/customerService/customerServiceActions";
import { resetListHospital } from "~/store/hospital/hospitalActions";
import { redirectToMedproId } from "~/store/login/actions";
import { getExtraConfig } from "~/store/totalData/actions";
import {
  selectPatientFromData,
  selectedPatientDetail
} from "~/store/patient/patientAction";
import {
  getPatientDetail,
  resetPatientForm,
  setPatientInfo
} from "~/store/patientForm/patientFormAction";

import { logOut } from "~/store/user/userAction";
import { client } from "~/utils/medproSDK";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const BookingPatientUpdateDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/BookingPatientUpdate"),
  loading: LoadableLoading,
  delay: 500
});

class BookingPatientUpdatePage extends Component {
  componentDidMount() {
    const {
      user: { info },
      cs: { cskhToken },
      location
    } = this.props;

    if (location.state?.patient) {
      this.props.selectPatientFromData(location.state.patient);
    }
    const { patientId } = location.state || {};

    if (patientId) {
      this.props.resetPatientForm();
      if (location.state?.patient) {
        this.props.handleSelectedPatient(location.state.patient);
      }

      this.props.getPatientDetail(patientId);
    } else {
      console.warn(
        "⚠️ No patientId found in location.state - using mock data for testing"
      );
    }

    if (info) {
      // đã đăng nhập thì kiểm tra thông tin người dùng
      if (String(info.isCS) === "true") {
        const _csToken =
          cskhToken || window.localStorage.getItem("cskhToken") || null;
        const _token =
          info?.token || window.localStorage.getItem("jwt") || null;

        client.setCskhToken(_csToken);
        client.setToken(_token);
        this.props.setCSToken(_csToken);
        this.props.resetListHospital();
        this.props.getExtraConfig();
      } else {
        window.location.href = "https://medpro.vn/";
        persistor.purge();
      }
    } else {
      this.props.redirectToMedproId();
    }
  }

  render() {
    const { user } = this.props;
    if (String(user?.info?.isCS) === "false" || !user?.info) {
      return null;
    }

    console.log("BookingPatientUpdatePage - props:", this.props);

    return (
      <React.Fragment>
        <BookingPatientUpdateDesktop {...this.props} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user,
    customerService: cs,
    patient: { selectedPatient },
    patientForm
  } = state;
  return {
    cs,
    user,
    device: type,
    selectedPatient,
    patientForm
  };
};

const mapDispatchToProps = {
  logOut: logOut,
  setCSToken,
  resetListHospital,
  getExtraConfig,
  redirectToMedproId,
  selectPatientFromData,
  getPatientDetail,
  resetPatientForm,
  setPatientInfo,
  handleSelectedPatient: selectedPatientDetail
};

const BookingPatientUpdatePageHelmet = withTitle({
  component: BookingPatientUpdatePage,
  title: `${hospitalName.value} | Cập nhật hồ sơ bệnh nhân`
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BookingPatientUpdatePageHelmet)
);
